import { init, browserTracingIntegration, captureConsoleIntegration } from "@sentry/vue";

/**
 *
 * @param {import("vue-router").Router} router
 * @returns {import("vue").FunctionPlugin}
 */
export function createSentry(router) {
  return function (app) {
    init({
      app,
      dsn: "https://710e63cacb8f3d08b3beb4c15077dd9d@o4511699948929024.ingest.de.sentry.io/4511700228243536",
      integrations: [browserTracingIntegration({ router }), captureConsoleIntegration({ levels: ["error"] })],
      ignoreErrors: ["AppError", "UnauthorizedError", "via a navigation guard", "Network Error"],
    });
  };
}
